/*eslint no-new-func: "off"*/
import { config } from '../../../config';

export const updateSystemSettings = (
  settings: { name: string; value: string; type: string }[],
) => {
  settings.forEach(param => {
    updateParamInRAM(param);
  });
};

export const updateParamInRAM = (param: {
  name: string;
  value: string;
  type: string;
}) => {
  try {
    let func;

    if (param.type === 'Object') {
      const _value = JSON.stringify(param.value);
      func = Function(
        'const config = arguments[0];' +
          `//console.log('${param.name} ->|: ' + JSON.stringify(${param.name}));` +
          `${param.name} = ${_value};` +
          `//console.log('${param.name} |->: ' + JSON.stringify(${param.name}));`,
      );
    } else if (param.type === 'Boolean' || param.type === 'Range') {
      const _value = param.value;
      func = Function(
        'const config = arguments[0];' +
          `//console.log('${param.name} ->|: ' + JSON.stringify(${param.name}));` +
          `${param.name} = ${_value};` +
          `//console.log('${param.name} |->: ' + JSON.stringify(${param.name}));`,
      );
    } else if (param.type === 'Array') {
      const _value = param.value;
      func = Function(
        'const config = arguments[0];' +
          `//console.log('${param.name} ->|: ' + JSON.stringify(${param.name}));` +
          `${param.name} = [${_value}];` +
          `//console.log('${param.name} |->: ' + JSON.stringify(${param.name}));`,
      );
    } else if (param.type === 'SelectListNumberValues') {
      const _value = param.value;
      /*console.log(`${param.name} = [${_value}].map(
        function (_val) {
          return { _id: '', code: _val, value: _val, name: '' + _val };
        },
      );`);*/
      func = Function(
        'const config = arguments[0];' +
          `//console.log('${param.name} ->|: ' + JSON.stringify(${param.name}));` +
          `${param.name} = [${_value}].map(
            function (_val) {
              return { _id: '', code: _val, value: _val, name: '' + _val };
            },
          );;` +
          `//console.log('${param.name} |->: ' + JSON.stringify(${param.name}));`,
      );
    } else if (param.type === 'SelectListStringValues') {
      const _value = param.value;
      /*console.log(`${param.name} = [${_value}].map(
        function (_val) {
          return { _id: '', code: _val, value: _val, name: '' + _val };
        },
      );`);*/
      func = Function(
        'const config = arguments[0];' +
          `//console.log('${param.name} ->|: ' + JSON.stringify(${param.name}));` +
          `${param.name} = '${_value}'.split(',').map(
            function (_val) {
              return { _id: '', code: _val, value: _val, name: '' + _val };
            },
          );;` +
          `//console.log('${param.name} |->: ' + JSON.stringify(${param.name}));`,
      );
    } else {
      func = Function(
        'const config = arguments[0];' +
          `//console.log('${param.name} ->|: ' + ${param.name});` +
          `${param.name} = \`${param.value}\`;` +
          `//console.log('${param.name} |->: ' + ${param.name});`,
      );
    }
    func(config);
  } catch (e) {
    console.log(
      'Error Updating Param ' +
        param.name +
        ' = ' +
        (param.type !== 'Object' ? param.value : JSON.stringify(param.value)) +
        ' : ' +
        e,
    );
  }
};
